<template>
	<div class="wages wrapper shadow level-setting">
		<div class="operation">
			<div class="left">
				<div class="main-title">其他设置</div>
			</div>
		</div>
		<div class="level-pane">
			<ul>
				<li>
					<div class="name">
						<span>住宿费</span>
					</div>
					<div class="base-pay">
						<span>扣款金额：</span>
						<el-input class="price-input" v-model="data.accommodation.amount" placeholder="住宿扣款金额" size="large" type="number">
							<template #prepend>￥</template>
						</el-input>
						<span>生效日期：</span>
						<el-date-picker v-model="data.accommodation.startDate" type="month" format="YYYY-MM" size="large"
							value-format="YYYY-MM-DD" placeholder="住宿费变动生效日期" />
					</div>
				</li>
				<li>
					<div class="name">
						<span>车补</span>
					</div>
					<div class="base-pay">
						<span>车补金额：</span>
						<el-input class="price-input" v-model="data.carFee.carFee" placeholder="车补金额" size="large" type="number">
							<template #prepend>￥</template>
						</el-input>
						<span>生效日期：</span>
						<el-date-picker v-model="data.carFee.startDate" type="month" format="YYYY-MM" size="large"
							value-format="YYYY-MM-DD" placeholder="车补变动生效日期" />
					</div>
				</li>
        <li>
          <div class="name">
            <span>高温补贴</span>
          </div>
          <div class="base-pay">
            <span>名称：</span>
            <el-input class="input" v-model="data.subsidyName" placeholder="请输入高温补贴名称" size="large">
            </el-input>
          </div>
        </li>
			</ul>
			<div class="operate-btn">
				<el-button type="primary" @click="saveClick" class="main-btn main-btn-primary save-btn">保存设置</el-button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		onMounted,
		ref
	} from "vue";
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import {
		fetchData,
		save
	} from "@/api/sysSetting";

	onMounted(() => {
		getData();
	});

	const data = ref({
		carFee: {
			carFee: '',
			startDate: ''
		},
		accommodation: {
			amount: '',
			startDate: ''
		}
	});

	const getData = () => {
		fetchData().then((res) => {
			data.value = res.data
			if (!data.value.carFee) {
				data.value.carFee = {
					carFee: '',
					startDate: ''
				}
			}
			if (!data.value.accommodation) {
				data.value.accommodation = {
					amount: '',
					startDate: ''
				}
			}
		});
	}

	// 保存设置
	const saveClick = () => {
		ElMessageBox.confirm("确定要保存设置吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
			.then(() => {
				save(data.value).then(() => {
					getData()
					ElMessage({
						type: "success",
						message: "保存成功！",
					});
				})
			})
			.catch(() => {});
	};
</script>

<style lang="scss" scoped>
	.level-setting {
		.level-pane {
			ul {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				li {
					width: 48%;
					display: flex;
					align-items: center;
					justify-content: space-between;
					background: #e0f2ff;
					padding: 5px 10px;
					margin: 0 0 10px 0;

					.name {
						span {
							font-size: 18px;
							font-weight: bold;
							color: $main-color;
						}
					}

					.base-pay {
						display: flex;
						align-items: center;

						span {
							white-space: nowrap;
						}

						::v-deep .el-input {
							width: 150px;
							.el-input__inner {
								font-size: 18px;
								font-weight: bold;
								color: $main-color;

								&::placeholder {
									font-size: 14px;
									font-weight: normal;
								}
							}
						}
						.price-input{
							margin: 0 10px 0 0;
							width: 180px;
						}

						.del-btn {
							margin: 0 0 0 10px;
							padding: 8px 10px;
							font-size: 18px;
						}
					}
				}
			}
		}

		.operate-btn {
			margin: 10vh auto 0;
			width: fit-content;

			.save-btn {
				width: 240px;
			}
		}
	}
	@media (max-width:1200px) {
		.level-pane{
			li{
				width: 100%!important;
			}
		}
	}
</style>
